import { transitYBIValidate } from "../../application/dtos/transit_ybi_validate";

export class transitYBIEntity {
    constructor( data ){ // cuando se recive un objeto con propiedades indefinidas en vez de las propiedades definidad de un objeto
        this.data = data
    }

    isValid() {
        return transitYBIValidate(this);
    }
}